// Utils
import cn from '../../../../utils/cn';

// Styles
import styles from './EnumField.module.css';

// Components
import SelectField from '../../../atoms/Select/Select';
import groupOptionsByOptGroup from '../../../../utils/optGroup/optGroup';

/**
 * BatchActionEnumInput - Simple select for enum values in batch actions (based on BatchActionSelect but without groups)
 * @param {object} props
 * @param {string | null} [props.value] - Current selected value
 * @param {(value: {label: string, value: string} | null) => void} props.onChange - Change handler
 * @param {string} [props.name] - Input name attribute
 * @param {boolean} [props.disabled] - Whether input is disabled
 * @param {boolean} [props.isReadOnly] - Locked; value remains in form
 * @param {{message?: string}} [props.error] - Validation error
 * @param {string} [props.className] - Additional CSS classes
 * @param {string} [props.placeholder] - Placeholder text
 * @param {string} [props.theme] - Theme of the select field
 * @param {ApiManagerTableFiltersSetAttributeMultipleSelectEnumOption[]} [props.options] - Options for the select field
 * @returns {JSX.Element} BatchActionEnumInput component
 */
function EnumMultiField({
  theme = 'default',
  value = null,
  options = [],
  onChange,
  name,
  disabled = false,
  isReadOnly = false,
  error = null,
  className = '',
  placeholder = '',
}) {
  const optionsOptGrouped = groupOptionsByOptGroup(options).map((group) => ({
    label: group.lib,
    options: group.options.map((option) => ({
      value: option.id,
      label: option.lib,
      color: option.color,
    })),
  }));

  return (
    <div className={cn([styles.wrapper, className])}>
      <div className={cn([
        styles.group,
        disabled && styles['enum-disabled'],
        isReadOnly && styles['enum-read-only'],
      ])}
      >
        <SelectField
          id={name}
          theme={theme}
          value={value}
          options={optionsOptGrouped}
          placeholder={placeholder}
          onChange={onChange}
          isMulti
          className={styles['enum-full-width']}
          disabled={disabled}
          isReadOnly={isReadOnly}
        />
      </div>

      {error && (
        <div className={styles.error} role="alert">
          {error.message}
        </div>
      )}
    </div>
  );
}

export default EnumMultiField;
